"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Persona_types_1 = require("./Persona.types");
var stylesImport = require("./Persona.scss");
var styles = stylesImport;
exports.PERSONA_SIZE = (_a = {},
    // All non-numerically named sizes are deprecated, use the numerically named classes below
    _a[Persona_types_1.PersonaSize.tiny] = 'ms-Persona--tiny ' + styles.rootIsSize10,
    _a[Persona_types_1.PersonaSize.extraExtraSmall] = 'ms-Persona--xxs ' + styles.rootIsSize24,
    _a[Persona_types_1.PersonaSize.extraSmall] = 'ms-Persona--xs ' + styles.rootIsSize28,
    _a[Persona_types_1.PersonaSize.small] = 'ms-Persona--sm ' + styles.rootIsSize40,
    _a[Persona_types_1.PersonaSize.regular] = '',
    _a[Persona_types_1.PersonaSize.large] = 'ms-Persona--lg ' + styles.rootIsSize72,
    _a[Persona_types_1.PersonaSize.extraLarge] = 'ms-Persona--xl ' + styles.rootIsSize100,
    _a[Persona_types_1.PersonaSize.size10] = 'ms-Persona--size10 ' + styles.rootIsSize10,
    _a[Persona_types_1.PersonaSize.size16] = 'ms-Persona--size16 ' + styles.rootIsSize16,
    _a[Persona_types_1.PersonaSize.size24] = 'ms-Persona--size24 ' + styles.rootIsSize24,
    _a[Persona_types_1.PersonaSize.size28] = 'ms-Persona--size28 ' + styles.rootIsSize28,
    _a[Persona_types_1.PersonaSize.size32] = 'ms-Persona--size32 ' + styles.rootIsSize32,
    _a[Persona_types_1.PersonaSize.size40] = 'ms-Persona--size40 ' + styles.rootIsSize40,
    _a[Persona_types_1.PersonaSize.size48] = 'ms-Persona--size48 ' + styles.rootIsSize48,
    _a[Persona_types_1.PersonaSize.size72] = 'ms-Persona--size72 ' + styles.rootIsSize72,
    _a[Persona_types_1.PersonaSize.size100] = 'ms-Persona--size100 ' + styles.rootIsSize100,
    _a);
exports.PERSONA_PRESENCE = (_b = {},
    _b[Persona_types_1.PersonaPresence.offline] = 'ms-Persona--offline ' + styles.rootIsOffline,
    _b[Persona_types_1.PersonaPresence.online] = 'ms-Persona--online ',
    _b[Persona_types_1.PersonaPresence.away] = 'ms-Persona--away ' + styles.rootIsAway,
    _b[Persona_types_1.PersonaPresence.dnd] = 'ms-Persona--dnd ' + styles.rootIsDoNotDisturb,
    _b[Persona_types_1.PersonaPresence.blocked] = 'ms-Persona--blocked ' + styles.rootIsBlocked,
    _b[Persona_types_1.PersonaPresence.busy] = 'ms-Persona--busy ' + styles.rootIsBusy,
    _b);
var _a, _b;
//# sourceMappingURL=PersonaConsts.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Persona/PersonaConsts.js
// module id = 20
// module chunks = 0